import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Lesson_createAutoEvaluation($evaluationData: CreateAutoEvaluation) {
    Lesson_createAutoEvaluation(evaluationData: $evaluationData) {
      id
      name
      position
      isDraft
      order
      duration
      isRandomQuestionOrder
      isAutomatic
    }
  }
`;

const LessonCreateAutoEvaluation = async evaluationData =>
  graphql(mutation, { evaluationData }).then(
    // eslint-disable-next-line camelcase
    ({ Lesson_createAutoEvaluation }) => Lesson_createAutoEvaluation
  );

export default LessonCreateAutoEvaluation;
